<template>
<header class="container">
    <div class="row">
        <div class="card text-light border-0 bg-info"><a name="arriba"></a>
            <img src="../assets/banner.jpg" class="img-fluid w-100" alt="...">
            <div class="card-img-overlay my-sm-auto my-md-auto "> 
                <div class="align-middle my-sm-auto my-md-5 glassefect py-md-5 py-sm-1">
                    <h5 class="card-title display-3 fw-bold text-center text-light">{{titulocabezal}}</h5>
                </div>
            </div>
        </div>
    </div>
</header>
</template>

<script>
export default {
    name:'Cabecera',
    data(){
        return{
            titulocabezal: 'PROGRAMADOR | DATA SCIENCE',
        }
    }

}
</script>

<style>
.glassefect{
    background-color: #ffffff10;
    backdrop-filter: blur(12px);
}

</style>